import { render } from "./ResultModal.vue?vue&type=template&id=4c7f90d0&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"

import "./ResultModal.vue?vue&type=style&index=0&id=4c7f90d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7f90d0"]])

export default __exports__